import React from "react";
import axios from 'axios';
import { connect } from "react-redux";

import MakeOrderBidding from './MakeOrderBiddingTest'
import MakeOrderPay from './MakeOrderPayTest'
import RepeatOrderModal from "./Modals/RepeatOrder";
import EditOrderModal from "./Modals/EditOrder";
import CancelOrderModal from "./Modals/CancelOrder";
import {
    updateOrderReceive,
    updateOrderRequest,
    cancelOrder,
    getOrderById,
} from '../../actions/orderActions';
import { getCameras } from '../../actions/cameraRequirementActions';
import { addMoneyUser } from '../../actions/session';
import {getHeader} from '../../helper';

class ParentComponent extends React.Component {

    state = {
        repeatOrder: {
            type: 'default',
            show: false,
            currentCamera: null,
        },

        editOrder: {
            type: 'default',
            show: false,
            loading: false,
        },

        cancelOrder: {
            type: 'default',
            show: false,
            prepareShowCancelModal: false,
        },
    }

    componentDidMount() {
        let camera = this.props.currentOrder.camera_requirement_id;

        if(camera) {
            let currentCamera = this.props.cameras.data[camera];
            if(currentCamera) {
                this.setState({
                    currentCamera: currentCamera
                })
            }
            else{
                this.props.dispatch(
                    getCameras(
                        {id: camera},
                        (data) => {
                            this.setState({
                                currentCamera: data
                            })
                        }
                    )
                );
            }
        }
    }

    repeatOrder(e) {
        e.preventDefault();

        this.setState({
            repeatOrder: {
                ...this.state.repeatOrder,
                show: true,
            }
        })
    }
    
    editOrder(e) {
        e.preventDefault();

        this.setState({
            editOrder: {
                ...this.state.editOrder,
                show: true,
            }
        })
    }

    editOrderClose() {
        this.setState({
            editOrder: {
                ...this.state.editOrder,
                show: false,
                type: 'default',
            }
        })
    }

    editOrderConfirm() {
        const {currentOrder, dispatch, company:{companies}, updateCompanyDataReceive} = this.props;
        if(!currentOrder) return false;
        
        const {company_id, total_price} = currentOrder;
        let company = {};
        
        if(currentOrder.company_id) {
            let currentCompany = companies.data.results.filter(item => item.id === currentOrder.company_id);
            if(!currentCompany.length) return false;
            
            company = Object.assign({}, currentCompany[0], {
                balance: (parseFloat(currentCompany[0].balance) + parseFloat(total_price))
            });
        }

        this.setState({
            editOrder: {
                ...this.state.editOrder,
                loading: true,
            }
        })

        axios.post(
            `${window.siteUrl}/api/v1/order/${currentOrder.id}/edit/`,
            {},
            {
                headers: getHeader()
            }
        )
        .then(response => {
            this.setState({
                editOrder: {
                    ...this.state.editOrder,
                    type: 'success',
                    loading: false,
                }
            });
            this.props.dispatch(updateOrderRequest())

            setTimeout(() => {
                this.props.dispatch(updateOrderReceive(response.data))
            }, 1500);

            if(company_id) {
                dispatch(updateCompanyDataReceive(company));
            }
            else{
                dispatch(addMoneyUser({price: total_price}))
            }
        })
        .catch(error => {
            this.setState({
                editOrder: {
                    ...this.state.editOrder,
                    type: 'error',
                    loading: false,
                }
            });
        });
    }
    
    repeatOrderConfirm() {
        const {currentOrder, history} = this.props;
        if(!currentOrder) return false;
        this.setState({repeatConfirmBtn: true});

        axios.post(
            `${window.siteUrl}/api/v1/order/${currentOrder.id}/duplicate/`,
            {},
            {
                headers: getHeader()
            }
        )
        .then(response => {
            this.setState({
                repeatOrder: {
                    ...this.state.repeatOrder,
                    type: 'success',
                    repeatConfirmBtn: false
                }
            });

            this.props.dispatch(updateOrderReceive({
                ...currentOrder,
                duplicates_count: currentOrder.duplicates_count++
            }));

            setTimeout(() => {
                this.props.history.replace("/makeorder/" + response.data.id, "state");
            }, 3000);
        })
        .catch(error => {
            this.setState({
                repeatOrder: {
                    ...this.state.repeatOrder,
                    type: 'error',
                },
                repeatConfirmBtn: false,
            });
        });
    }

    repeatOrderClose() {
        this.setState({
            repeatOrder: {
                ...this.state.repeatOrder,
                show: false,
                type: 'default',
            },
        })
    }

    cancelOrder(e) {
        e.preventDefault();
        const {session, dispatch, currentOrder} = this.props;
        const { token } = session;

        this.setState({
            cancelOrder: {
                ...this.state.cancelOrder,
                prepareShowCancelModal: true,
            }
        });

        dispatch(
            getOrderById(
                {id: currentOrder.id },
                getHeader(),
                true,
                () => {

                    this.setState({
                        cancelOrder: {
                            ...this.state.cancelOrder,
                            show: true,
                            prepareShowCancelModal: false,
                        }
                    });
                }
            )
        );
    }

    cancelOrderConfirm() {
        const {currentOrder, history, dispatch} = this.props;
        if(!currentOrder) return false;
        axios.post(
            `${window.siteUrl}/api/v1/order/${currentOrder.id}/cancel_by_user/`,
            {},
            {
                headers: getHeader()
            }
        )
        .then(response => {
            dispatch(cancelOrder({
                ...currentOrder,
                is_failed: true,
            }));

            this.setState({
                cancelOrder: {
                    ...this.state.cancelOrder,
                    type: 'success',
                }
            })
            setTimeout(() => {
                this.props.history.replace("/orders/customer");
            }, 3000);
        })
        .catch(error => {
            this.setState({
                cancelOrder: {
                    ...this.state.cancelOrder,
                    type: 'error',
                }
            });
        });
    }

    cancelOrderClose() {
        this.setState({
            cancelOrder: {
                ...this.state.cancelOrder,
                show: false,
                type: 'default',
                prepareShowCancelModal: false,
            }
        })
    }

    getComponent() {
        const {currentOrder, params, history} = this.props;
        const {currentCamera} = this.state;
        
        switch (currentOrder.status) {
            case 2:
                return  <MakeOrderBidding
                            repeatOrder={(e) => this.repeatOrder(e)}
                            editOrder={(e) => this.editOrder(e)}
                            cancelOrder={(e) => this.cancelOrder(e)}
                            params={params}
                            currentOrder={currentOrder}
                            currentCamera={currentCamera}
                        />;
            default:
                return  <MakeOrderPay
                            repeatOrder={(e) => this.repeatOrder(e)}
                            editOrder={(e) => this.editOrder(e)}
                            cancelOrder={(e) => this.cancelOrder(e)}
                            params={params}
                            currentOrder={currentOrder}
                            currentCamera={currentCamera}
                            history={history}
                        />
        }
    }

    render() {
        return (
            <div>

                <CancelOrderModal
                    inputProps={this.state.cancelOrder}
                    currentOrder={this.props.currentOrder}
                    onConfirm={() => this.cancelOrderConfirm()}
                    onCancel={() => this.cancelOrderClose()}
                />

                <RepeatOrderModal
                    inputProps={this.state.repeatOrder}
                    repeatConfirmBtn={this.state.repeatConfirmBtn}
                    onConfirm={() => this.repeatOrderConfirm()}
                    onCancel={() => this.repeatOrderClose()}
                />

                <EditOrderModal
                    inputProps={this.state.editOrder}
                    onConfirm={() => this.editOrderConfirm()}
                    onCancel={() => this.editOrderClose()}
                />

                {
                    this.getComponent()
                }

            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        ...state
    };
};

export default connect(mapStateToProps)(ParentComponent);


// WEBPACK FOOTER //
// ./src/components/MakeOrder/ParentComponent.js